import { useNavigate } from "react-router-dom";
import { Button, Card, Grid, styled, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { PATH } from "../../../config";
import { resetPassword } from "app/redux/api";
import { Reset_Password } from "app/redux/actions";

const passwordRules = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

const validationSchema = Yup.object().shape({
    password: Yup.string()
        .matches(passwordRules, 'Password must be at least 6 characters long, contain one uppercase letter, one number, and one special character')
        .required('Password is required'),

    // confirmPassword: Yup.string()
    //     .oneOf([Yup.ref('password'), null], 'Passwords must match')
    //     .required('Confirm Password is required'),
});

const StyledRoot = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5ff",

    minHeight: "100vh !important",

    "& .card": {
        maxWidth: 800,
        margin: "1rem",
        borderRadius: 12,
        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)"

    },

    ".img-wrapper": {
        display: "flex",
        padding: "2rem",
        alignItems: "center",
        justifyContent: "center",
    },
}));

const ContentBox = styled("div")(({ }) => ({
    padding: 32,
}));

export default function ResetPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleFormSubmit = (values) => {
        dispatch(Reset_Password(values.otp, { password: values.password }, moveToNext, moveToFailure));
    };
    const moveToFailure = (message) => {
        toast.error(message);
    };
    const moveToNext = () => {
        toast.success("Password Reset Successfull!");
        navigate(PATH.LOGIN);
    }
    return (
        <StyledRoot>
            <Card className="card">
                <Grid container>
                    <Grid item xs={12}>
                        <div className="img-wrapper">
                            <img
                                width="300"
                                src="/assets/images/technodevs.jpeg"
                                alt="Forgot Password Illustration"
                            />
                        </div>

                        <ContentBox>
                            <Formik
                                initialValues={{ password: "", otp: "" }}
                                validationSchema={validationSchema}
                                onSubmit={handleFormSubmit}
                            >
                                {({ handleSubmit, handleChange, values, errors, touched }) => (
                                    <form onSubmit={handleSubmit}>
                                        <TextField
                                            type="number"
                                            name="otp"
                                            size="small"
                                            label="OTP"
                                            value={values.otp}
                                            variant="outlined"
                                            onChange={handleChange}
                                            error={Boolean(errors.otp && touched.otp)}
                                            helperText={touched.otp && errors.otp}
                                            sx={{ mb: 3, width: "100%" }}
                                        />
                                        <TextField
                                            type="password"
                                            name="password"
                                            size="small"
                                            label="New Password"
                                            value={values.password}
                                            variant="outlined"
                                            onChange={handleChange}
                                            error={Boolean(errors.password && touched.password)}
                                            helperText={touched.password && errors.password}
                                            sx={{ mb: 3, width: "100%" }}
                                        />
                                        {/* <TextField
                                            type="password"
                                            name="reset-password"
                                            size="small"
                                            label="Confirm New Password"
                                            value={values.confirmPassword}
                                            variant="outlined"
                                            onChange={handleChange}
                                            error={Boolean(errors.confirmPassword && touched.confirmPassword)}
                                            helperText={touched.confirmPassword && errors.confirmPassword}
                                            sx={{ mb: 3, width: "100%" }}
                                        /> */}
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                        >
                                            Reset Password
                                        </Button>

                                        <Button
                                            fullWidth
                                            color="primary"
                                            variant="outlined"
                                            onClick={() => navigate(-1)}
                                            sx={{ mt: 2 }}
                                        >
                                            Go Back
                                        </Button>
                                    </form>
                                )}
                            </Formik>
                        </ContentBox>
                    </Grid>
                </Grid>
            </Card>
        </StyledRoot>
    );
}
